<app-navbar></app-navbar>

<section class="pt-15 md:pt-0 h-(1/2dvh)" id="landing">
    <video #videoElement loop autoplay muted playsinline class="w-full h-(1/2dvh)" (loadedmetadata)="onVideoLoaded()">
        <source src="src/assets/video/What future would you like to see .mp4" type="video/mp4">
    </video>
</section>

<section class="bg-white text-black border-0">
    <div class="container mx-auto py-10 px-4 text-center">
        <div class="max-w-5xl mx-auto">
            <p class="text-xl lg:text-2xl mb-4 animate-fade animate-delay-1000 animate-ease-in uppercase">
                {{texts.title[0]}} <br> {{texts.title[1]}} <br> {{texts.title[2]}} 
                <span class="text-green-400 font-semibold">{{texts.title[3]}}</span>
            </p>
        </div>
        <div class="w-full mx-auto flex justify-center">
            <a href="https://mundoev.com?utm_source=prinxcr&utm_medium=referral&utm_campaign=llantas" target="_blank" rel="noopener noreferrer">
                <div class="bg-green-500 text-white py-4 px-12 rounded-lg shadow-lg text-center transition-all duration-300 transform hover:scale-105 hover:shadow-2xl cursor-pointer">
                    <p class="text-xl md:text-2xl font-semibold uppercase tracking-wide">{{texts.distributor_banner}}</p>
                </div>
            </a>
        </div>
        


    </div>
</section>


<section class="bg-white text-black py-3">
    <div class="mx-2">
        <div #info_llantas class="grid grid-cols-1 md:grid-cols-2 gap-2">
            <!-- Component: Image overlay card -->
            <div class="overflow-hidden bg-white rounded shadow-md text-slate-500 shadow-slate-200">
                <!-- Image -->
                <figure class="relative">
                    <img src="/assets/img/landing/67d04e981cf5c306aed3d0b0_xlab 2.jpg" alt="card image" class="object-cover w-full h-96"/>
                    <figcaption class="absolute bottom-0 left-0 w-full p-6 text-white bg-gradient-to-t from-black">
                        <h3 class="text-2xl font-semibold text-green-500 uppercase">{{texts.tires.xlab.title}}</h3>
                        <p class="text-base opacity-75">{{texts.tires.xlab.subtitle}}</p>
                        <!-- Component: Small outline basic button -->
                        <a href="/tires/product/xlab-comfort-ev" routerLink="/tires/product/xlab-comfort-ev">
                            <button class="mt-4 inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide 
                                transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500
                                text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700
                                focus:text-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none bg-black/60
                                transform hover:scale-110">
                                    <span class="uppercase">{{texts.tires.xlab.button_text}}</span>
                            </button>
                                <!-- End Small outline basic button -->
                         </a>
                        
                    </figcaption>
                </figure>
            </div>
            <!-- End Image overlay card -->

            <!-- Component: Image overlay card -->
            <div class="overflow-hidden bg-white rounded shadow-md text-slate-500 shadow-slate-200">
                <!-- Image -->
                <figure class="relative">
                    <img src="/assets/img/landing/67d0559d00b50e0e0cf1b8de_xnex.jpg" alt="card image" class="object-cover w-full h-96" />
                    <figcaption class="absolute bottom-0 left-0 w-full p-6 text-white bg-gradient-to-t from-black">
                        <h3 class="text-2xl font-semibold text-green-500 uppercase">{{texts.tires.xnex.title}}</h3>
                        <p class="text-base opacity-75">{{texts.tires.xnex.subtitle}}</p>
                        <!-- Component: Small outline basic button -->
                        <a href="/tires/product/xnex-sport-ev" routerLink="/tires/product/xnex-sport-ev">
                            <button class="mt-4 inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide 
                                transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap border-green-500
                                text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700
                                focus:text-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none bg-black/60
                                transform hover:scale-110">
                                    <span class="uppercase">{{texts.tires.xnex.button_text}}</span>
                            </button>
                                <!-- End Small outline basic button -->
                        </a>
                    </figcaption>
                </figure>
            </div>
            <!-- End Image overlay card -->
        </div>

         <div #redes class="grid grid-cols-1 gap-2 my-2">
            <!-- Component: Image overlay card -->
            <div class="overflow-hidden bg-white rounded shadow-md text-slate-500 shadow-slate-200">
                <!-- Image -->
                <figure class="relative">
                    <img src="/assets/img/landing/67d2f727e026f5395ccc667b_banner 2.png" alt="card image" class="object-cover w-full min-h-[60dvh] md:min-h-[45dvh]" />
                    <figcaption class="absolute bottom-0 left-0 w-full md:h-4/5 lg:h-3/4 p-6 text-white bg-gradient-to-t from-black">
                        <div class="grid grid-cols-1 xl:grid-cols-3 items-center justify-between h-full">
                            <div class="md:col-span-2">
                                <p class="text-4xl uppercase">{{texts.social.title[0]}} <span class="text-green-400">{{texts.social.title[1]}}?</span></p>
                                <p class="text-xl">{{texts.social.subtitle}}</p>

                            </div>
                            <div class="items-center justify-center mx-auto">
                                <a href="https://www.facebook.com/profile.php?id=61577968478344" target="_blank" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="9000" class="me-6 inline-flex items-center justify-center h-24 lg:h-16 xl:h-24 gap-2 text-sm 
                                font-medium tracking-wide transition duration-300 rounded-full focus-visible:outline-none 
                                justify-self-center whitespace-nowrap transform hover:scale-110">
                                    <span>
                                        <img src="/assets/img/landing/672a22eeb26999ac92d064e6_icon_fb.svg" class="w-20 lg:w-16 xl:w-24" alt="" srcset="">
                                    </span>
                                </a>
                                <a href="https://www.instagram.com/mundoev_cr?igsh=MThrd2V0ODByZzhuMQ==" target="_blank" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1000" class="me-6 inline-flex items-center justify-center h-24 lg:h-16 xl:h-24 gap-2 text-sm 
                                font-medium tracking-wide transition duration-300 rounded-full focus-visible:outline-none 
                                justify-self-center whitespace-nowrap transform hover:scale-110">
                                    <span><img src="/assets/img/landing/672a22e440553a7859cb75da_icon_ig.svg" class="w-20 lg:w-16 xl:w-24" alt="" srcset=""></span>
                                </a>
                                <!-- <button data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1100" class="me-6 inline-flex items-center justify-center h-24 lg:h-16 xl:h-24 gap-2 text-sm 
                                font-medium tracking-wide transition duration-300 rounded-full focus-visible:outline-none 
                                justify-self-center whitespace-nowrap transform hover:scale-110">
                                    <span><img src="/assets/img/landing/672a22f839bee918ee0a0731_icon_in.svg" class="w-20  lg:w-16 xl:w-24" alt="" srcset=""></span>
                                </button> -->
                                
                            </div>
                        </div>
                        
                        
                        
                    </figcaption>
                </figure>
            </div>
            <!-- End Image overlay card -->
            
        </div>
    </div>

</section>

<section #futuro_sostenible class="relative bg-white text-black">
    <div class="relative h-[70vh] flex items-center overflow-hidden shadow-lg">
        <img src="/assets/img/landing/673380d122e5bce6a9a42fc9_banner-sustainability-full.png" alt="Sustainable Environment" class="absolute inset-0 w-full h-full object-cover object-center opacity-90" />
        <div class="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent z-10"></div>
        <div class="relative z-10 text-left px-6 container md:w-2/3 mx-auto">
            <h1 class="text-4xl md:text-6xl font-extrabold mb-4 drop-shadow-lg text-left text-white">
                {{texts.future.title}}
            </h1>
            <p class="text-lg md:text-2xl mb-8 max-w-2xl drop-shadow text-left text-white">
                {{texts.future.subtitle}}
            </p>

            <!-- Component: Base outline elevated button -->
            <a href="/about-us#sostenibilidad" routerLink="/about-us#sostenibilidad">
                <button class="inline-flex items-center justify-center h-10 gap-2 px-5 text-sm rounded-full font-medium tracking-wide transition duration-300 border focus-visible:outline-none whitespace-nowrap border-green-500 text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 hover:shadow-sm hover:shadow-green-200 focus:shadow-sm focus:shadow-green-200 disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none transform hover:scale-110">
                    <span>{{texts.future.more_info_btn}}</span>
                </button>
            </a>
            
            <!-- End Base outline elevated button -->
        </div>
        <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
    </div>
</section>

<!--<section #ultimas_noticias class="bg-white text-black">
    <div class="container mx-auto md:w-8/12 py-12 px-4">
        <h2 class="text-3xl font-bold mb-6 text-left">Últimas Noticias</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="overflow-hidden bg-white rounded shadow-sm text-slate-500 shadow-slate-200">
                <figure>
                    <img src="https://cdn.prod.website-files.com/65379f6a9f143ec19d8f2310/68306b19392aa61e458e8a84_eld12-p-1080.jpg" alt="card image" class="hover:z-10 hover:scale-105 object-cover aspect-video w-full transition-all duration-500" />
                </figure>
                <div class="p-6">
                    <header class="flex gap-4 mb-4">
                    
                    <div>
                        <h3 class="text-xl font-medium text-slate-700">Innovación en Movilidad Eléctrica</h3>
                        <p class="text-sm text-slate-400">Por Equipo MundoEV, 10 jun 2024</p>
                    </div>
                    </header>
                    <p>
                        Descubre las últimas tendencias y avances en neumáticos diseñados especialmente para vehículos eléctricos. Tecnología, sostenibilidad y rendimiento se unen para transformar la movilidad del futuro.
                    </p>
                </div>
                <div class="flex justify-start gap-2 p-2 ps-6 pt-0 pb-4">
                    <button class="inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide text-white 
                    transition duration-300 rounded-full focus-visible:outline-none whitespace-nowrap bg-green-500 hover:bg-green-600
                     focus:bg-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:bg-green-300 disabled:shadow-none">
                        <span>Más información</span>
                    </button>
                </div>
            </div>
            
            <div class="overflow-hidden bg-white rounded shadow-sm text-slate-500 shadow-slate-a">
                <figure>
                    <img src="https://cdn.prod.website-files.com/65379f6a9f143ec19d8f2310/671f7fe05fa49ab8da2e0c73_auto_5832-p-1080.jpg" alt="card image" class="hover:z-10 hover:scale-105 object-cover aspect-video w-full transition-all duration-500" />
                </figure>
                <div class="p-6">
                    <header class="flex gap-4 mb-4">
                    
                    <div>
                        <h3 class="text-xl font-medium text-slate-700">Premio a la Innovación Verde</h3>
                        <p class="text-sm text-slate-400">Por Equipo MundoEV, 5 jun 2024</p>
                    </div>
                    </header>
                    <p>
                        PRINX recibe reconocimiento internacional por su compromiso con la sostenibilidad y el desarrollo de neumáticos ecológicos para vehículos eléctricos.
                    </p>
                </div>
                <div class="flex justify-start gap-2 p-2 ps-6 pt-0 pb-4">
                    <button class="inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide text-white 
                    transition duration-300 rounded-full focus-visible:outline-none whitespace-nowrap bg-green-500 
                    hover:bg-green-600 focus:bg-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:bg-green-300 disabled:shadow-none">
                        <span>Más información</span>
                    </button>
                </div>
            </div>
            <div class="overflow-hidden bg-white rounded shadow-sm text-slate-500 shadow-slate-a">
                <figure>
                    <img src="https://cdn.prod.website-files.com/65379f6a9f143ec19d8f2310/668d0ac064f6d6bd8c82da89_red-roofs-of-ancient-houses-in-the-port-with-moore-2023-11-27-05-02-03-utc-p-1080.jpg" alt="card image" class="hover:z-10 hover:scale-105 object-cover aspect-video w-full transition-all duration-500" />
                </figure>
                <div class="p-6">
                    <header class="flex gap-4 mb-4">
                        <div>
                            <h3 class="text-xl font-medium text-slate-700">Paisajes Urbanos y Sostenibilidad</h3>
                            <p class="text-sm text-slate-400">Por Equipo MundoEV, 12 jun 2024</p>
                        </div>
                    </header>
                    <p>
                        Descubre cómo la integración de espacios urbanos tradicionales con soluciones sostenibles transforma la vida en las ciudades costeras. Innovación y respeto por el entorno se unen para crear comunidades más verdes y habitables.
                    </p>
                </div>
                <div class="flex justify-start gap-2 p-2 ps-6 pt-0 pb-4">
                    <button class="inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide text-white 
                    transition duration-300 rounded-full focus-visible:outline-none whitespace-nowrap bg-green-500 
                    hover:bg-green-600 focus:bg-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:bg-green-300 disabled:shadow-none">
                        <span>Más información</span>
                    </button>
                </div>
            </div>
            <div class="overflow-hidden bg-white rounded shadow-sm text-slate-500 shadow-slate-a">
                <figure>
                    <img src="https://cdn.prod.website-files.com/65379f6a9f143ec19d8f2310/66830f02a2a40cf9037a50ac_thumbnail_prinx-europe-besucheransturm-p-1080.jpg" alt="card image" class="hover:z-10 hover:scale-105 object-cover aspect-video w-full transition-all duration-500" />
                </figure>
                <div class="p-6">
                    <header class="flex gap-4 mb-4">
                        <div>
                            <h3 class="text-xl font-medium text-slate-700">Éxito en la Feria de Hannover</h3>
                            <p class="text-sm text-slate-400">Por Equipo MundoEV, 2 jun 2024</p>
                        </div>
                    </header>
                    <p>
                        PRINX Europa atrajo una multitud de visitantes en la feria de Hannover, destacando la innovación y el interés creciente por los neumáticos para vehículos eléctricos. Un evento que refuerza nuestro compromiso con la movilidad sostenible y la tecnología de vanguardia.
                    </p>
                </div>
                <div class="flex justify-start gap-2 p-2 ps-6 pt-0 pb-4">
                    <button class="inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide text-white 
                    transition duration-300 rounded-full focus-visible:outline-none whitespace-nowrap bg-green-500 
                    hover:bg-green-600 focus:bg-green-700 disabled:cursor-not-allowed disabled:border-green-300 disabled:bg-green-300 disabled:shadow-none">
                        <span>Más información</span>
                    </button>
                </div>
            </div>
        </div>

    </div>
</section> -->

<section #premios class="bg-black text-white">
    <div class="w-full py-12 px-4">
        <h2 class="text-3xl font-bold mb-6 text-center uppercase">
            <span class="text-green-500 award">
                {{texts.awards.title[0]}}
            </span>
            {{texts.awards.title[1]}}
        </h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
            <!-- Component: Image overlay card -->
            <div class="h-[500px] overflow-hidden bg-white rounded transition-all duration-300">
                <!-- Image -->
                <figure class="relative group">
                    <img src="/assets/img/landing/659fa48f8d96a7bdece836aa_Awards_Rome.webp" alt="card image" class="group-hover:z-10 group-hover:scale-105 object-cover h-[500px] w-full transition-all duration-300" />
                    <figcaption class="absolute bottom-0 left-0 w-full p-6 text-white bg-gradient-to-t from-slate-900 opacity-100 xl:opacity-0 xl:group-hover:opacity-100 transition-opacity duration-300">
                        <div class="flex flex-col items-center justify-center h-[500px] w-full mx-auto">
                            <img src="/assets/img/landing/65538cbcfaf9e1fc197dbdb7_Award Italy.webp" alt="" srcset="">
                            <div class="mt-4">
                                <p class="text-base opacity-75 text-center uppercase">{{texts.awards.events[0].country}}</p>
                                <h3 class="text-xl font-semibold uppercase text-green-500">{{texts.awards.events[0].title}}</h3>
                                
                            </div>
                            
                        </div>
                    </figcaption>
                </figure>
            </div>
            <!-- End Image overlay card -->

            <!-- Component: Image overlay card -->
            <div class="h-[500px] overflow-hidden bg-white rounded transition-all duration-300 ">
                <!-- Image -->
                <figure class="relative group">
                    <img src="/assets/img/landing/659fa491a7d2044d287e466e_Awards_NewYork.webp" alt="card image" class="group-hover:z-10 group-hover:scale-105 object-cover h-[500px] w-full transition-all duration-300" />
                    <figcaption class="absolute bottom-0 left-0 w-full p-6 text-white bg-gradient-to-t from-slate-900 opacity-100 xl:opacity-0 xl:group-hover:opacity-100 transition-opacity duration-300">
                        <div class="flex flex-col items-center justify-center h-[500px] w-full mx-auto">
                            <img src="/assets/img/landing/65538caf05836414d8cb5806_Award ny.webp" alt="" srcset="">
                            <div class="mt-4">
                                <p class="text-base opacity-75 text-center uppercase">{{texts.awards.events[1].country}}</p>
                                <h3 class="text-xl font-semibold uppercase text-green-500">{{texts.awards.events[1].title}}</h3>
                            </div>
                            
                        </div>
                    </figcaption>
                </figure>
            </div>
            <!-- End Image overlay card -->
             <!-- Component: Image overlay card -->
            <div class="h-[500px] overflow-hidden bg-white rounded transition-all duration-300 ">
                <!-- Image -->
                <figure class="relative group">
                    <img src="/assets/img/landing/659fa48eaa1fa56a41b9c422_Awards_Paris.webp" alt="card image" class="group-hover:z-10 group-hover:scale-105 object-cover h-[500px] w-full transition-all duration-300" />
                    <figcaption class="absolute bottom-0 left-0 w-full p-6 text-white bg-gradient-to-t from-slate-900 opacity-100 xl:opacity-0 xl:group-hover:opacity-100 transition-opacity duration-300">
                        <div class="flex flex-col items-center justify-center h-[500px] w-full mx-auto">
                            <img src="/assets/img/landing/65538cc51d8c2c8b07657140_Award Paris.webp" alt="" srcset="">
                            <div class="mt-4">
                                <p class="text-base opacity-75 text-center uppercase">{{texts.awards.events[2].country}}</p>
                                <h3 class="text-xl font-semibold uppercase text-green-500">{{texts.awards.events[2].title}}</h3>
                            </div>
                            
                        </div>
                    </figcaption>
                </figure>
            </div>
            <!-- End Image overlay card -->
        </div>
    </div>
</section>

<section #innovacion class="bg-black text-white">
    <div class="p-12 max-w-7xl mx-auto">
        <div class="text-center">
            <p class="text-base">{{texts.details.subtitle}}</p>
            <h2 class="text-2xl md:text-3xl container md:w-1/2 mx-auto uppercase">{{texts.details.title}}</h2>
            
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
            <div class="p-6 rounded-lg shadow-md flex items-center justify-center">
                <video src="/assets/img/landing/65379f6a9f143ec19d8f22b6_671636bc1eeef22eaf5992e2_TechnologyPrinx_500px_5mb-transcode.mp4" loop autoplay muted playsinline #videoLlanta alt="card image" class="object-cover container md:w-2/3" ></video>
            </div>
            <div class="p-6 rounded-lg shadow-md ">
                <h3 class="text-3xl font-semibold mb-4 uppercase">
                    {{texts.details.details[0].title}}
                </h3>
                <p>
                    {{texts.details.details[0].description[0]}} <br> <br>
                    {{texts.details.details[0].description[1]}} <br> <br>
                    {{texts.details.details[0].description[2]}} <br> <br>          
                </p>
                <a href="/excellence/technology" routerLink="/excellence/technology">
                    <button class="inline-flex items-center justify-center h-10 gap-2 px-5 
                    text-sm rounded-full font-medium tracking-wide transition duration-300 
                    border focus-visible:outline-none whitespace-nowrap border-green-500 
                    text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700
                    focus:text-green-700 hover:shadow-sm disabled:shadow-none transform hover:scale-110 uppercase">
                        <span>{{texts.details.details[0].more_info_btn}}</span>
                    </button>
                </a>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
            <div class="md:mt-24 p-6 rounded-lg shadow-md ">
                <h3 class="text-3xl font-semibold mb-4 uppercase">{{texts.details.details[1].title}}</h3>
                <p>
                    {{texts.details.details[1].description[0]}}
                </p>
            </div>
            <div class="p-6 rounded-lg shadow-md flex items-center justify-center">
                <video src="/assets/img/landing/65a787f0e4ae12986f2f34ee_PerformanceVideo-transcode.mp4" loop autoplay muted playsinline #videoPerformance alt="card image" class="object-cover container md:w-2/3 rounded-md" ></video>
            </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8">
            <div class="p-6 rounded-lg shadow-md flex items-center justify-center">
                <img src="/assets/img/landing/67d2ed7c7c9630f84c813dbb_Acquare.jpg" alt="card image" class="object-cover container md:w-2/3 rounded-md" />
            </div>
            <div class="p-6 rounded-lg shadow-md ">
                <h3 class="text-3xl font-semibold mb-4 uppercase">{{texts.details.details[2].title}}</h3>
                <p>
                    {{texts.details.details[2].description[0]}}
                    <br><br>
                    {{texts.details.details[2].description[1]}}
                </p>
                <a href="/excellence/tuv-sud" routerLink="/excellence/tuv-sud">
                    <button class="mt-4 inline-flex items-center justify-center h-10 gap-2 px-5 
                    text-sm rounded-full font-medium tracking-wide transition duration-300 
                    border focus-visible:outline-none whitespace-nowrap border-green-500 
                    text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700
                    focus:text-green-700 hover:shadow-sm disabled:shadow-none transform hover:scale-110 uppercase">
                        <span>{{texts.details.details[2].more_info_btn}}</span>
                    </button>
                </a>
            </div>
        </div>
    </div>
</section>

<app-footer></app-footer>